"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const { Fragment } = React;
const src_1 = require("@rover/ts-bootstrap/dist/src");
const renderPreviewDescription = (description, media) => {
    if (description) {
        return (React.createElement(src_1.Text, { text: description, size: "large", textStyle: {
                width: 200,
                height: 48,
                display: 'block',
                margin: `${media === 'Mobile' ? '24px' : '40px'} auto`,
            } }));
    }
};
const renderFullScreenPreview = (args) => {
    const { animation, buttonLeft, buttonLeftCallback, buttonRight, buttonRightCallback, children, description, device, previewTitle, } = args;
    const buttonLeftStyle = {
        marginLeft: device === 'Mobile' ? 24 : 32,
    };
    const mobileStyle = {
        margin: '0 auto',
        marginTop: 56,
        width: 326,
        animation: 'open ease-out 400ms',
    };
    const style = {
        height: '100%',
        width: '100%',
        animation: animation,
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: 'white',
        overflow: 'hidden',
    };
    const tabletStyle = {
        height: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        marginTop: 64,
        animation: 'open ease-out 600ms',
        flexDirection: 'column',
    };
    return (React.createElement("div", { style: style },
        React.createElement(src_1.NavBar, { buttonLeft: buttonLeft, buttonLeftCallback: buttonLeftCallback, buttonRight: buttonRight, buttonRightCallback: buttonRightCallback, style: {
                buttonLeftStyle: { outerStyle: Object.assign({}, buttonLeftStyle) },
            }, title: previewTitle }),
        React.createElement("div", { style: device === 'Mobile' ? mobileStyle : tabletStyle },
            device === 'Mobile' && renderPreviewDescription(description, device),
            React.createElement(src_1.PhoneComponent, { device: device, viewLockScreen: true }, children),
            device === 'Tablet' && renderPreviewDescription(description, device))));
};
const PhonePreview = (props) => {
    const { children, description, device } = props;
    if (device === 'Mobile' || device === 'Tablet') {
        return renderFullScreenPreview(props);
    }
    if (device === 'Desktop') {
        return (React.createElement(Fragment, null,
            React.createElement(src_1.PhoneComponent, { device: device, viewLockScreen: true }, children),
            renderPreviewDescription(description, device)));
    }
};
exports.default = PhonePreview;
